
import MultiSceneCommand from './MultiSceneCommand';
import showPositionOnTrajectory from './showPositionOnTrajectory';

export default class MultiSceneCommandShowPosition extends MultiSceneCommand {

    constructor(options) {
        super(options);
        this._name = 'SHOW_POSITION';
    }

    execute(multiSceneViewer, params) {
        showPositionOnTrajectory(
            multiSceneViewer,
            params.trjName, params.photoName, params.x, params.y, params.z, 0, 0
        );
    }
}
